import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectorRef,
  OnInit,
} from "@angular/core";
import { WizardSubstep } from "../../../common/wizard/wizard-subtep.interface";
import { DomSanitizer } from "@angular/platform-browser";
import { TagRepository } from "../../../../domain/tag-repository";
import {
  RecurringType,
  DisplayOn,
  FilterCondition,
  TimingType,
  ShowDuring,
} from "../../../../domain/enums";
import { UserService } from "../../../../domain/user-service";
import { Channel } from "../../../../domain/channel";
import { AutopilotRule } from "../../../../domain/rule";

@Component({
  selector: "icn-autopilot-rule-wizard-step2-substep2",
  templateUrl: "./substep2.html",
  styleUrls: ["./substep2.scss"],
})
export class AutopilotRuleWizardStep2Substep2Component
  implements WizardSubstep, OnInit
{
  constructor(
    private userService: UserService,
    private changeDetectorRef: ChangeDetectorRef,
    private sanitizer: DomSanitizer,
    private tagRepository: TagRepository,
  ) {}

  @Input()
  rule: AutopilotRule;

  @Input()
  channel: Channel;

  noteToDisplay;
  showNote;

  tags = this.tagRepository.getGeneralTags().map((tag) => tag.name);

  showVideoBasedConditionForTags = false;

  channelTimeCodeFormat: "FPS" | "MS" = "FPS";

  onVideoBasedTimingMinSecChange(val) {
    this.rule.videoBasedTimingMinSec = val;
    //this.rule.videoBasedTimingMinSecChange.emit(this.videoBasedTimingMinSec);
  }
  onTimeBasedIntervalChange(val) {
    this.rule.timeBasedIntervalMins = val;
    //this.timeBasedIntervalChange.emit(val);
  }

  onVideoBasedFilterTagsItemClicked(e) {
    let self = this;
    if (e.value === null) {
      //clicked on 'all'
      if (e.multipleSelectedValues.length === this.tags.length + 1) {
        //all tags + null
        self.rule.videoBasedFilterTags = [];
      } else {
        self.rule.videoBasedFilterTags = this.tags.map((tag) => tag);
      }
      setTimeout(() => {
        self.changeDetectorRef.markForCheck();
      });
    }
    //this.rule.videoBasedFilterTagsChange.emit(this.rule.videoBasedFilterTags);
    this.makeNote();
  }

  onShowVideoBasedContitionForTagsChange(val) {
    this.showVideoBasedConditionForTags = val;
    if (!val && this.rule.videoBasedFilterCondition !== FilterCondition.Or) {
      this.rule.videoBasedFilterCondition = FilterCondition.Or;
      //this.rule.videoBasedFilterConditionChange.emit(FilterCondition.Or);
    }
  }

  onVideoBasedFilterConditionChange(val) {
    this.rule.videoBasedFilterCondition = val;
    //this.videoBasedFilterConditionChange.emit(val);
    this.makeNote();
  }

  videoBasedDisplayOnOptions = [
    { name: "All Videos", value: DisplayOn.AllVideos },
    { name: "Selected Videos", value: DisplayOn.SelectedVideos },
  ];

  changeVideoBasedDisplayOn(val: DisplayOn) {
    this.rule.videoBasedDisplayOn = val;
    //this.rule.videoBasedDisplayOnChange.emit(val);
  }

  onVideoBasedTimingChange(val) {
    this.rule.videoBasedTiming = val;
    //this.rule.videoBasedTimingChange.emit(val);
  }

  onVideoBasedTimingIntervalChange(val) {
    this.rule.videoBasedTimingInterval = val;
    //this.videoBasedTimingIntervalChange.emit(val);
  }

  alwaysBasedDuringOptions = [
    { name: "All", value: ShowDuring.All },
    { name: "Commercials", value: ShowDuring.Commercials },
    { name: "Videos", value: ShowDuring.Videos },
  ];

  canGoNext() {
    switch (this.rule.recurringType) {
      case RecurringType.Time: {
        return !!this.rule.timeBasedIntervalMins;
      }

      case RecurringType.Video: {
        if (!this.rule.videoBasedDisplayOn) {
          return false;
        }
        if (this.rule.videoBasedDisplayOn === DisplayOn.SelectedVideos) {
          if (
            this.showVideoBasedConditionForTags &&
            !this.rule.videoBasedFilterCondition
          ) {
            return false;
          }
        }

        if (!this.rule.videoBasedTiming) {
          return false;
        }
        return true;
      }

      case RecurringType.Always: {
        return !!this.rule.alwaysBasedDuring;
      }
    }

    return true;
  }

  ngOnInit() {
    this.channelTimeCodeFormat = this.channel.framerate ? "FPS" : "MS";
    this.showVideoBasedConditionForTags =
      this.rule.videoBasedFilterCondition !== FilterCondition.Or;

    this.makeNote();
  }

  makeNote() {
    let tags = this.getTags();
    let cond = this.getCond();
    let note = this.getPrefix() + this.getBody() + this.getSuffix();
    this.noteToDisplay = this.sanitizer.bypassSecurityTrustHtml(note);
    this.showNote = this.rule.videoBasedFilterTags.length > 0;
  }

  getPrefix() {
    if (this.rule.videoBasedFilterCondition === 3)
      return "<span>All tags <b><u>Except</u></b> ";
    else return "<span>Video Tags ";
  }

  getSuffix() {
    if (this.rule.videoBasedFilterTags.length > 3) return "...</span>";
    return "</span>";
  }

  getBody() {
    let ans = "";
    let tags = this.getTags();
    let cond = this.getCond();
    let i;
    for (i = 0; i < tags.length - 1; i++) {
      ans = ans + '"' + tags[i] + '"' + cond;
    }
    ans = ans + '"' + tags[i] + '"';
    return ans;
  }

  getTags() {
    if (this.rule.videoBasedFilterTags.length <= 2)
      return this.rule.videoBasedFilterTags;
    else return this.rule.videoBasedFilterTags.slice(0, 3);
  }

  getCond() {
    if (
      this.rule.videoBasedFilterTags.length >= 2 &&
      this.rule.videoBasedFilterCondition === 2
    )
      return "<b><u> And </u></b>";
    else return ", ";
  }

  setVideoBasedFitToWholeVideo(val: boolean) {
    console.log("setVideoBasedFitToWholeVideo", val);
    this.rule.videoBasedFitToWholeVideo = val;
    //this.videoBasedFitToWholeVideoChange.emit(val)
  }

  validateTimeBasedIntervalMins(newValueInMins: number) {
    const newValueInMs = newValueInMins * 60000;
    if (this.rule.timeBasedGraphicDurationMs > newValueInMs) {
      this.rule.timeBasedGraphicDurationMs = newValueInMs;
    }
  }

  onOverrideMediaDurationClick(ev) {
    if (ev.target.checked) {
      this.rule.videoBasedTimingVideoDurationMs = 0;
    } else {
      this.rule.videoBasedTimingVideoDurationMs = null;
    }
  }
}
